// extracted by mini-css-extract-plugin
export default {"modalOverlay":"TI-z","modalContent":"UI-z","header":"VI-z","close":"WI-z"};